<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Ghostly Tales of Bloomington</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head">T<span class="small">ABLE OF</span> C<span class="small">ONTENTS</span></p>
<p class="toc"><span href="#/Title" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></p>
<p class="toca"><a href="#/Chapter1"><span class="toc-space">1</span> CAPTAIN SKULL AND THE CURSE OF THE CALIFORNIA COUSIN</a></p>
<p class="toca"><span href="#/Chapter2" title="Link target outside of Sample"><span class="toc-space">2</span> PANCAKES AND PLANS</span></p>
<p class="toca"><span href="#/Chapter3" title="Link target outside of Sample"><span class="toc-space">3</span> ON TOP OF THE WORLD</span></p>
<p class="toca"><span href="#/Chapter4" title="Link target outside of Sample"><span class="toc-space">4</span> OLD IRONSIDES</span></p>
<p class="toca"><span href="#/Chapter5" title="Link target outside of Sample"><span class="toc-space">5</span> THE THIEF’S KNOT</span></p>
<p class="toca"><span href="#/Chapter6" title="Link target outside of Sample"><span class="toc-space">6</span> A PIRATE YARN</span></p>
<p class="toca"><span href="#/Chapter7" title="Link target outside of Sample"><span class="toc-space">7</span> THE GHOST TRAIL</span></p>
<p class="toca"><span href="#/Chapter8" title="Link target outside of Sample"><span class="toc-space">8</span> X MARKS THE SPOT</span></p>
<p class="toca"><span href="#/Chapter9" title="Link target outside of Sample"><span class="toc-space">9</span> TREASURE</span></p>
<p class="toca"><span href="#/Chapter10" title="Link target outside of Sample"><span class="toc-space">10</span> THE CURSE AND THE SATCHEL</span></p>
<p class="toca"><span href="#/Chapter11" title="Link target outside of Sample"><span class="toc-space">11</span> CAPTAIN VS. CAPTAIN</span></p>
<p class="toca"><span href="#/Chapter12" title="Link target outside of Sample"><span class="toc-space">12</span> A SEAFOOD CELEBRATION</span></p>
<p class="toca"><span href="#/Chapter13" title="Link target outside of Sample"><span class="toc-space">13</span> BACK TO THE COMMON</span></p>
<p class="toca"><span href="#/Chapter14" title="Link target outside of Sample"><span class="toc-space">14</span> THE TREASURE MAP</span></p>
<p class="toca"><span href="#/Chapter15" title="Link target outside of Sample"><span class="toc-space">15</span> HISTORY MAKERS</span></p>
<p class="toca"><span href="#/Chapter16" title="Link target outside of Sample"><span class="toc-space">16</span> PIRATES IN THE PARK</span></p>
<p class="toca"><span href="#/Epilogue" title="Link target outside of Sample"><span class="toc-space">17</span> EPILOGUE</span></p>
<p class="toca"><span href="#/Author" title="Link target outside of Sample">ABOUT THE AUTHOR</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?4367d5ba